module.exports = __webpack_public_path__ + "static/ritorno-kindvriendelijk-bcccfe8d5f1138f26588f46af6706204.jpg";